import React, { useContext, useEffect, useState } from "react";
import Icon from "../Icon";
import sidebarRoutes from "../../routes/sidebar";
import { NavLink } from "react-router-dom";
import SidebarSubmenu from "./SidebarSubmenu";
import { AuthContext } from "../../context/AuthContext";
import API from "../../api/api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  Dropdown,
  DropdownItem,
  WindmillContext,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Badge,
  Label,
} from "@windmill/react-ui";
import { useLocalStorage } from "../../utils/useLocalStorage";
import { permissions } from "../../utils/Permissions";
import Select from "react-select";

const SidebarContent = () => {
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);

  function handleDropdownMenuClick() {
    setIsDropdownMenuOpen(!isDropdownMenuOpen);
  }

  const queryClient = useQueryClient();
  const { user } = useContext(AuthContext);

  const masterRoutes = [
    ...sidebarRoutes,
    // {
    //   resource: "logs",
    //   icon: "DocumentChartBar",
    //   name: "Server Logs",
    //   path: "logs",
    // },
  ];

  // Local storage
  const [selectedUser, setSelectedUser] = useLocalStorage("selectedUser");

  // Operator & Company filter
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    setSelectedOperator(
      JSON.parse(selectedUser)?.role === "company"
        ? {
            label: JSON.parse(selectedUser)?.Operator?.name,
            value: JSON.parse(selectedUser)?.Operator,
          }
        : JSON.parse(selectedUser)?.role === "operator"
        ? {
            label: JSON.parse(selectedUser)?.name,
            value: JSON.parse(selectedUser),
          }
        : null
    );
    setSelectedCompany(
      JSON.parse(selectedUser)?.role === "company"
        ? {
            label: JSON.parse(selectedUser)?.name,
            value: JSON.parse(selectedUser),
          }
        : null
    );
  }, [selectedUser]);

  // Get Operator
  const getOperator = async () => {
    const { data } = await API("GET", "/operator/list");
    return data;
  };

  const { data: dataOperator, refetch: refetchOp } = useQuery(
    ["operator"],
    getOperator,
    {
      enabled:
        JSON.parse(selectedUser).role === "master" ||
        user?.Account?.type === "master",
    }
  );

  // Get Company
  const getCompany = async () => {
    let user = JSON.parse(selectedUser);
    let operatorId;
    if (user?.role === "operator") {
      operatorId = user?._id;
    } else if (user?.role === "company") {
      operatorId = user?.Operator?._id;
    }
    const { data } = await API("GET", "/company/list", null, {
      headers: {
        "x-operator-id": operatorId,
      },
    });

    return data;
  };

  const { data: dataCompany, refetch: refetchComp } = useQuery(
    ["company"],
    getCompany,
    {
      enabled:
        (user?.Account?.type === "master" &&
          JSON.parse(selectedUser).role === "operator") ||
        (user?.Account?.type === "master" &&
          JSON.parse(selectedUser).role === "company") ||
        user?.Account?.type === "operator",
    }
  );

  useEffect(() => {
    if (
      (user?.Account?.type === "master" &&
        JSON.parse(selectedUser).role === "operator") ||
      (user?.Account?.type === "master" &&
        JSON.parse(selectedUser).role === "company") ||
      user?.Account?.type === "operator"
    )
      refetchComp();
    if (
      JSON.parse(selectedUser).role === "master" ||
      user?.Account?.type === "master"
    )
      refetchOp();
  }, [selectedUser]);
  return (
    <>
      <div className="py-4 text-primary">
        <div
          className="ml-5 flex items-center"
          onClick={handleDropdownMenuClick}
        >
          <p className="text-xl font-bold text-primary underline cursor-pointer">
            {JSON.parse(selectedUser)?.name ?? user?.Account?.name}{" "}
            {/* <Badge className="mt-2">{JSON.parse(selectedUser)?.role}</Badge> */}
          </p>
          {user?.Account?.type !== "company" && (
            <div className="ml-3">
              {isDropdownMenuOpen ? (
                <Icon
                  className="w-5 h-5 text-primary"
                  aria-hidden="true"
                  icon="ChevronUp"
                  type="solid"
                />
              ) : (
                <Icon
                  className="w-5 h-5 text-primary"
                  aria-hidden="true"
                  icon="ChevronDown"
                  type="solid"
                />
              )}
            </div>
          )}
        </div>
        {isDropdownMenuOpen && (
          <div className="mx-5">
            {user?.Account?.type === "master" && (
              <>
                {selectedOperator && (
                  <Label className="font-bold mt-2">Operator</Label>
                )}
                <Select
                  isClearable
                  onChange={(e) => {
                    setSelectedCompany(null);
                    if (e === null) {
                      setSelectedUser(
                        JSON.stringify({
                          _id: user?.Account?._id,
                          name: user?.Account?.name,
                          role: "master",
                        })
                      );
                      setSelectedOperator(null);
                    } else {
                      setSelectedOperator(e);
                      setSelectedUser(JSON.stringify(e.value));
                    }
                  }}
                  placeholder="Select operator..."
                  options={dataOperator?.data?.map((x) => ({
                    label: x?.name,
                    value: {
                      _id: x?._id,
                      name: x?.name,
                      role: "operator",
                      isBillingProfile: x?.isBillingProfile,
                      // type: x?.role,
                    },
                  }))}
                  value={selectedOperator}
                  className="my-2"
                />
              </>
            )}
            {user?.Account?.type !== "company" &&
              dataCompany?.data?.length > 0 &&
              selectedOperator && (
                <>
                  {selectedCompany && (
                    <Label className="font-bold mt-2">Company</Label>
                  )}
                  <Select
                    isClearable
                    options={dataCompany?.data?.map((x) => ({
                      label: x?.name,
                      value: {
                        _id: x?._id,
                        name: x?.name,
                        role: "company",
                        // type: x?.role,
                        Operator: {
                          _id: x?.Operator?._id,
                          name: x?.Operator?.name,
                          role: "operator",
                          isBillingProfile: x?.Operator?.isBillingProfile,
                        },
                        currency: x?.currency,
                      },
                    }))}
                    onChange={(e) => {
                      if (e === null) {
                        setSelectedCompany(null);
                        setSelectedOperator(JSON.parse(selectedUser)?.Operator);
                        setSelectedUser(
                          JSON.stringify(JSON.parse(selectedUser)?.Operator)
                        );
                      } else {
                        setSelectedCompany(e);
                        setSelectedUser(JSON.stringify(e.value));
                      }
                    }}
                    placeholder="Select company..."
                    value={selectedCompany}
                    className="my-2"
                  />
                </>
              )}
          </div>
        )}

        <ul className="mt-6">
          {masterRoutes
            .filter((i) => {
              if (selectedUser) {
                let initialPermissions =
                  permissions[JSON.parse(selectedUser)?.role];
                return (
                  initialPermissions
                    // user?.Account?._id === JSON.parse(selectedUser)?._id
                    //   ? [...initialPermissions, "user"]
                    //   :
                    .includes(i.resource)
                );
              }
              return true;
            })
            .map((route) =>
              route.routes ? (
                <SidebarSubmenu route={route} key={route.name} />
              ) : (
                <li className="relative px-6 py-3" key={route.name}>
                  <NavLink
                    to={`/app/${route.path}`}
                    className={({ isActive }) =>
                      `${
                        isActive
                          ? `text-primary font-semibold`
                          : `text-gray-600`
                      } inline-flex items-center w-full text-sm transition-colors duration-150 hover:text-primary`
                    }
                  >
                    <Icon
                      className="w-5 h-5"
                      aria-hidden="true"
                      icon={route.icon}
                    />
                    <span className="ml-4">{route.name} </span>
                  </NavLink>
                </li>
              )
            )}
        </ul>
      </div>
    </>
  );
};

export default SidebarContent;
